import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar.jsx";
import axios from "axios";

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("ALL");

  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/queries")
      .then((res) => {
        const mappedQuotes = res.data.map((q) => {
          const dateObj = new Date(q.date);

          return {
            id: q.id,
            date: dateObj.toLocaleDateString("en-GB"),
            time: dateObj.toLocaleTimeString("en-GB"),
            name: q.name,
            email: q.email,
            mobile: q.phone,
            message: q.message,
            status: q.status || "PENDING",
          };
        });

        setQuotes(mappedQuotes);
      })
      .catch((err) => {
        console.error("Failed to fetch quotes:", err);
      });
  }, []);

  const filteredQuotes = quotes.filter((q) => {
    const matchesSearch =
      q.name?.toLowerCase().includes(search.toLowerCase()) ||
      q.email?.toLowerCase().includes(search.toLowerCase());

    const matchesStatus = sort === "ALL" || q.status === sort;

    return matchesSearch && matchesStatus;
  });

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.put(
        `https://api.livestockify.com/api/admin/queries/${id}/status`,
        { status: newStatus }
      );

      setQuotes((prev) =>
        prev.map((q) => (q.id === id ? { ...q, status: newStatus } : q))
      );
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main */}
      <div className="flex-1 bg-white rounded-l-2xl overflow-y-auto h-screen p-4 md:p-6 pl-14 md:pl-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <h1 className="text-xl font-semibold text-green-700">Queries</h1>

          <div className="flex flex-wrap items-center gap-3">
            {/* Search */}
            <div className="relative">
              <input
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border px-8 py-1.5 rounded-md text-sm"
              />
            </div>

            {/* Sort */}
            <div className="flex items-center gap-2">
              <span className="text-sm">Sort By</span>
              <select
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                className="border px-3 py-1.5 rounded-md text-sm"
              >
                <option value="ALL">All</option>
                <option value="PENDING">Pending</option>
                <option value="APPROVED">Approved</option>
                <option value="REJECTED">Rejected</option>
              </select>
            </div>
          </div>
        </div>

        {/* Quotes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredQuotes.map((q) => (
            <div
              key={q.id}
              className="border rounded-xl p-4 shadow-sm flex flex-col justify-between"
            >
              {/* Top Info */}
              <div className="text-xs text-gray-500 flex justify-between mb-2">
                <span>{q.date}</span>
                <span>{q.time}</span>
                <span className="text-green-700 font-medium">
                  {/* Quote ID: {q.quoteId} */}
                  Quote ID: #{q.id}
                </span>
              </div>

              {/* Details */}

              <div className="space-y-2 text-sm">
                {/* Name */}
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Name</span>
                  <span className="text-green-700">{q.name}</span>
                </div>

                {/* Mail */}
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Mail</span>
                  <span className="text-green-700">{q.email}</span>
                </div>

                {/* Mobile */}
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Mobile</span>
                  <span className="text-green-700">{q.mobile}</span>
                </div>

                {/* Message (FULL WIDTH) */}
                <div>
                  <span className="font-medium text-gray-700">Message</span>
                  <p className="text-gray-700 mt-1 leading-snug">{q.message}</p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-between mt-4">
                <span
                  className={`text-sm font-medium ${
                    q.status === "PENDING"
                      ? "text-orange-500"
                      : q.status === "APPROVED"
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {q.status}
                </span>
                <div className="flex gap-2">
                  {q.status === "PENDING" && (
                    <>
                      <button
                        onClick={() => handleStatusChange(q.id, "APPROVED")}
                        className="bg-green-700 text-white text-xs px-3 py-1 rounded-md"
                      >
                        Mark as Approved
                      </button>

                      <button
                        onClick={() => handleStatusChange(q.id, "REJECTED")}
                        className="bg-red-600 text-white text-xs px-3 py-1 rounded-md"
                      >
                        Mark as Rejected
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
